import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { PaymentMethodsUI } from '@grandvisionhq/payments';
import { Footer } from '../modules/Footer/Footer.js';
import { StepNames } from '../models/shared.js';

const StepPayment = ({ labels , onNextClick , onPrevClick , selectedPaymentMethod , onPaymentMethodSelected , onHandlePayment , cartId , addAdditionalPaymentCosts , qrCodeForm , orderInProgress ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: "checkout-step checkout-step--payment"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: "checkout-step__title"
    }, labels.paymentMethodTitle), labels.paymentMethodSecure && /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step__subtitle"
    }, labels.paymentMethodSecure), /*#__PURE__*/ React.createElement(PaymentMethodsUI, {
        cartId: cartId,
        onPaymentMethodSelected: onPaymentMethodSelected,
        paymentMethodName: selectedPaymentMethod !== null && selectedPaymentMethod !== void 0 ? selectedPaymentMethod : '',
        onHandlePayment: onHandlePayment,
        addAdditionalPaymentCosts: addAdditionalPaymentCosts,
        qrCodeForm: qrCodeForm,
        orderInProgress: orderInProgress
    }), /*#__PURE__*/ React.createElement(Footer, {
        selectedPaymentMethod: selectedPaymentMethod,
        nextStepHidden: true,
        stepName: StepNames.Payment,
        nextStepDisabled: false,
        onPrevStep: onPrevClick,
        onNextStep: onNextClick
    }))
;

export { StepPayment };
//# sourceMappingURL=StepPayment.js.map
